import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../types"

export const confirmConvertingPlanState: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    confirmConvertingPlanModal: true
  }),
  exit: assign<Context>({
    confirmConvertingPlanModal: false
  }),
  on: {
    CONVERT_TO_ADAPTIVE: {
      target: "convert_to_adaptive",
      actions: assign((_ctx, _evt) => ({
        seconds: 0
      }))
    },
    CONVERT_TO_MANUAL: {
      target: "convert_to_manual"
    },
    CANCEL: { target: "#StudyPlan.edit_plan.idle" }
  }
}
